/**
 * Mobile styles
 * Styles specific to mobile devices
 */

// Mobile-specific styles for the container
export const mobileContainerStyles = {
  padding: '16px 0',
  width: '100%',
  backgroundColor: '#FFFFFF',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
};

// Mobile-specific styles for the grid container (replacing carousel)
export const mobileCarouselContainerStyles = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  padding: '0 16px',
  boxSizing: 'border-box',
  overflow: 'visible',
  '.slick-track': {
    gap: '8px',
  },
  '.slick-slide': {
    margin: 0,
  },
  '.slick-list': {
    margin: 0,
    overflow: 'visible',
    paddingLeft: 0,
    paddingRight: 0,
  },
  overflowX: 'auto',
  marginLeft: 0,
  marginRight: 0,
  paddingLeft: 0,
  paddingRight: 0,
};

// Mobile-specific styles for the grid layout
export const mobileGridStyles = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: '16px',
  padding: '16px',
  justifyContent: 'space-between',
  width: '100%'
};

// Mobile-specific styles for brand cards
export const mobileBrandCardStyles = {
  borderRadius: '10px',
  border: '1px solid rgba(0, 0, 0, 0.08)',
  height: '140px',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  width: '150px',
  flex: '0 0 150px',
  marginLeft: '8px',
  '&:first-of-type': {
    marginLeft: '16px',
  },
};

// Mobile-specific styles for brand image container
export const mobileBrandImageContainerStyles = {
  padding: '12px',
};

// Mobile-specific styles for brand name container
export const mobileBrandNameStyles = {
  padding: '8px',
};

// Mobile-specific styles for brand typography
export const mobileBrandTypographyStyles = {
  fontSize: '0.85rem',
};

// Mobile alternative styles
export const mobileAlternativeBrandCardStyles = {
  ...mobileBrandCardStyles,
  // Mobile specific overrides for alternative layout
};

export const mobileAlternativeBrandImageContainerStyles = {
  ...mobileBrandImageContainerStyles,
  // Mobile specific overrides for alternative layout
};

export const mobileAlternativeBrandNameStyles = {
  ...mobileBrandNameStyles,
  // Mobile specific overrides for alternative layout
};

export const mobileAlternativeBrandTypographyStyles = {
  ...mobileBrandTypographyStyles,
  // Mobile specific overrides for alternative layout
};

// Mobile-specific styles for the title
export const mobileTitleStyles = {
  fontSize: '1.5rem',
  fontWeight: 600,
  textAlign: 'center',
  marginBottom: '16px',
  color: '#0A3954',
  width: '100%',
  padding: '0 16px'
};

// Styles for the original vertical layout on mobile
export const mobileVerticalGridStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  padding: '16px',
  alignItems: 'center',
  width: '100%'
};

export const mobileVerticalBrandCardStyles = {
  width: '140px',
  height: '120px',
  padding: 0,
  marginBottom: '8px'
}; 